import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'glamorous';
import Spinkit from 'react-spinkit';

import { mixins } from '../../../styles';

const TRANSITION_DURATION_MS = 600;

const Spinner = ({
  isReady,
  transitionDuration,
  theme
}) => (
  <div
    style={{
      zIndex: 9999,
      ...mixins.absoluteCenter,
      opacity: isReady ? 0 : 1,
      transition: `opacity ${transitionDuration}ms ease-in-out`,
    }}
  >
    <Spinkit
      fadeIn="quarter"
      name="ball-beat"
      color={theme.primary.base}
    />
  </div>
);

Spinner.propTypes = {
  isReady: PropTypes.bool,
  transitionDuration: PropTypes.number,
};

Spinner.defaultProps = {
  isReady: false,
  transitionDuration: TRANSITION_DURATION_MS,
};

export default withTheme(Spinner);



// WEBPACK FOOTER //
// ./src/components/ui/Spinner/Spinner.js